import { withPropSimple } from './higherOrderFunctions'

import { REDUCER_NAMES_KEG_COLLECTION_BOOKINGS as defaultSlice } from '../../constants'

export const getProp = withPropSimple(defaultSlice)
